// 1: 圖片上傳 2: 創意框架 3: 創意框架+圖片上傳
export const EXTRA_UPLOAD_FEATURE_TYPES = {
    IMAGE_UPLOAD: 1,
    //未來要改成 3
    CREATIVE_FRAME: 2
};
